import * as ActionTypes from '@storeOld/actions'

import API from '@/api'

export const localStorageMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case ActionTypes.LOGOUT_SUCCESS:
      API.Auth.token = null
      window.localStorage.removeItem('token')
      break
    case ActionTypes.SET_AUTH: {
      const { token } = action.payload

      API.Auth.token = token

      break
    }
    default:
    // do nothing
  }

  next(action)
}
